var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"container"},[_c('b-row',{staticClass:"logoutContainer",attrs:{"align-h":"center","align-v":"center"}},[_c('b-col',{staticClass:"loginWrapper p-4",attrs:{"lg":6}},[_vm._v(" See you soon! ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }